export function enhancedCataloguePageBanner({ state, action }) {
  return {
    ...state,
    enhancedCataloguePageBannerIndex: action.enhancedCataloguePageBannerIndex,
  };
}
